// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ads_integration".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { metaIntegrationStatusValues, tokenStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "meta_ads_integration" table (1:1 with a DB row, on the wire). */
export const metaAdsIntegrationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    connectedById: z.string(),
    configurationStatus: z.enum(metaIntegrationStatusValues),
    adAccountId: z.string().nullable(),
    adAccountName: z.string().nullable(),
    defaultPageId: z.string().nullable(),
    availableBusinesses: z.unknown().nullable(),
    availableAdAccounts: z.unknown().nullable(),
    availablePages: z.unknown().nullable(),
    facebookUserName: z.string().nullable(),
    facebookUserEmail: z.string().nullable(),
    facebookUserPictureUrl: z.string().nullable(),
    isActive: z.boolean(),
    tokenStatus: z.enum(tokenStatusValues),
    encryptedCredentials: z.string(),
    tokenExpiresAt: z.string().datetime().nullable(),
    connectionMethod: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    lastSyncError: z.string().nullable(),
    lastSyncErrorAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdsIntegration.js.map